import { useContext } from 'react';
import { InvoicesContext } from '../contexts/invoicesContext';

export default function useInvoices() {
    return useContext(InvoicesContext);
}
